const PREFIX = 'profile';

export const ProfileQueryKeys = {
  rootKey: [PREFIX],

  offerKey: [PREFIX, 'offer'],
  permissions: [PREFIX, 'permissions'],
} as const;
